const configBoardTemplate = {
    homenews: {
        emptyLayout: 'BoardEmptyDefaultLayout',
        listLayout: 'BoardListHomeNewsLayout'
    },
    homedonate: {
        emptyLayout: 'BoardEmptyDefaultLayout',
        listLayout: 'BoardListHomeDonateLayout'
    },
    business: {
        filterLayout: 'BoardFilterDefaultLayout',
        emptyLayout: 'BoardEmptyDefaultLayout',
        listLayout: 'BoardListBusinessLayout',
        paginationLayout: 'PaginationDefaultLayout'
    },
    businessDetail: {
        detailLayout: 'BoardDetailDefaultLayout',
    },
    financial: {
        filterLayout: 'BoardFilterDefaultLayout',
        emptyLayout: 'BoardEmptyDefaultLayout',
        listLayout: 'BoardListFinancialLayout',
        paginationLayout: 'PaginationDefaultLayout'
    },
    financialDetail: {
        detailLayout: 'BoardDetailDefaultLayout',
    },
    news: {
        filterLayout: 'BoardFilterDefaultLayout',
        emptyLayout: 'BoardEmptyDefaultLayout',
        listLayout: 'BoardListNewsLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    newsDetail: {
        detailLayout: 'BoardDetailDefaultLayout',
    },
    donate: {
        filterLayout: 'BoardFilterDefaultLayout',
        emptyLayout: 'BoardEmptyDefaultLayout',
        listLayout: 'BoardListDonateLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    donateDetail: {
        detailLayout: 'BoardDetailDefaultLayout',
    },
    primeDonate: {
        emptyLayout: 'BoardEmptyDefaultLayout',
        listLayout: 'BoardListPrimeLayout',
    },
    primeDonateDetail: {
        detailLayout: 'BoardDetailDefaultLayout',
    },
    album: {
        filterLayout: 'BoardFilterDefaultLayout',
        emptyLayout: 'BoardEmptyDefaultLayout',
        listLayout: 'BoardListAlbumLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    albumDetail: {
        detailLayout: 'BoardDetailDefaultLayout',
    },

    businessSearch: {
        filterLayout: 'BoardFilterDefaultLayout',
        emptyLayout: 'BoardEmptySearchLayout',
        listLayout: 'BoardListSearchLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    financialSearch: {
        filterLayout: 'BoardFilterDefaultLayout',
        emptyLayout: 'BoardEmptySearchLayout',
        listLayout: 'BoardListSearchLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    newsSearch: {
        filterLayout: 'BoardFilterDefaultLayout',
        emptyLayout: 'BoardEmptySearchLayout',
        listLayout: 'BoardListSearchLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    donateSearch: {
        filterLayout: 'BoardFilterDefaultLayout',
        emptyLayout: 'BoardEmptySearchLayout',
        listLayout: 'BoardListSearchLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    albumSearch: {
        filterLayout: 'BoardFilterDefaultLayout',
        emptyLayout: 'BoardEmptySearchLayout',
        listLayout: 'BoardListSearchLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },


}

export default {
    methods: {
        returnBoardTemplateConfig(type) {
            return configBoardTemplate[type];
        }
    }
}
